/**
 * Motion Design Tokens
 * Duration and easing values per Bennie style guide §8
 */

const ENTER_EASING = 'cubic-bezier(0.2, 0.8, 0.2, 1)';

export const motion = {
  duration: {
    instant: '100ms',
    fast: '150ms',
    normal: '200ms',
    slow: '300ms',
    slower: '500ms',
    slowest: '600ms',
  },
  easing: {
    default: 'cubic-bezier(0.4, 0, 0.2, 1)',
    in: 'cubic-bezier(0.4, 0, 1, 1)',
    out: 'cubic-bezier(0, 0, 0.2, 1)',
    // Decelerating entrance for tab/project content. Keyframes: tabIn, projIn (theme/globalStyles.ts).
    enter: ENTER_EASING,
  },
  animation: {
    tabIn: `tabIn 0.32s ${ENTER_EASING} both`,
    projIn: `projIn 0.26s ${ENTER_EASING} 0.06s both`,
  },
} as const;

export type MotionToken = typeof motion;
